export const Card = ({
  title,
  subtitle,
  extra,
  children,
  className = '',
  bodyClassName = '',
  flush = false,
  padded = false,
  interactive = false,
  style,
}) => {
  const classes = [
    'wm-card',
    padded && 'wm-card--pad',
    interactive && 'wm-card--interactive',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const hasHeader = title || extra;

  return (
    <section className={classes} style={style}>
      {hasHeader && (
        <header className='wm-card__header'>
          <div>
            {title && <h2 className='wm-card__title'>{title}</h2>}
            {subtitle && <div className='wm-card__subtitle'>{subtitle}</div>}
          </div>
          {extra && <div className='wm-card__extra'>{extra}</div>}
        </header>
      )}
      {padded ? (
        children
      ) : (
        <div
          className={['wm-card__body', flush && 'wm-card__body--flush', bodyClassName]
            .filter(Boolean)
            .join(' ')}
        >
          {children}
        </div>
      )}
    </section>
  );
};
